import googlePlay from '../assets/img/DownloadOnGooglePlay.svg';

export const DownloadOnGooglePlay = () => {
    return (
        <a className='w-full box-border bg-osGrey-4 rounded-[18px] p-3 flex items-center justify-center max-h-[60px]' href="https://play.google.com/store/apps/details?id=com.obsessless.app" target="_blank">
            <img src={googlePlay} alt="Google Play" className='w-full h-full object-contain' />
        </a>
    );
};

